
import React from 'react';
import $ from 'jquery'

class DataItem {
    tags = [];
    name = "";

    hasTags(tags) {
        let items = tags.length;
        for (let item in tags) {
            if (this.tags.includes(item)) {
                items--;
            }
        }
        return (items === 0);
    }

    match(tags, name) {
        return (name === this.name) && this.hasTags(tags);
    }

    addTags(tags) {
        for (let item in tags) {
            if (!this.hasTags([item])) {
                tags.push(item);
            }
        }
    }

}

export class DataStorage {

    constructor() {
        this.data = {
        };

        this.namespaces = [];
        this.ns = (tag, id) => {
            if (this.namespaces.includes(tag)) {
                this.namespaces.push(tag);
            }
            this.namespaces.push(tag);
            return tag + "/" + id;
        }
    }

    getGroup = (tag) => { /*FAKE*/
        //todo with DataItem if needed
        /*FAKE*/ let _data = DataItem;
        /*FAKE*/  return !_data;
    }

    getItem = (tag, id, permanent = false) => {
        let _id = this.ns(tag, id);
        if (permanent) {
            let value = window.sessionStorage.getItem(_id);
            return (value ? value : undefined)
        }
        else {
            return (this.data.hasOwnProperty(_id) ? this.data[_id] : undefined);
        }
    }

    setItem = (tag, id, value, permanent = false) => {
        let _id = this.ns(tag, id);
        this.data[_id] = value;
        if (permanent) {
            window.sessionStorage.setItem(_id, value);
        }
    }

    removeItem = (tag, id, permanent = false) => {
        let _id = this.ns(tag, id);
        let _data = this.data[_id];
        delete this.data[_id];
        if (permanent) {
            window.sessionStorage.removeItem(_id);
        } 
        return _data;
    }

    tags = () => { return this.namespaces; }

}

/* private StorageItem hides underlying logic */
class StorageItem extends React.Component {

    defaultProps = {
        value: {}
    }

    constructor(props) {
        super(props);

        this.NAME = () => { return "StorageItem" };

        this.valueChangeCallbacks = $.Callbacks();

        this.get = this.get.bind(this);
        this.update = this.update.bind(this);
        this.error = this.error.bind(this);
        this.subscribe = this.subscribe.bind(this);
        this.unsubscribe = this.unsubscribe.bind(this);
        this.createProvider = this.createProvider.bind(this);
        this.createConsumer = this.createConsumer.bind(this);


    }

    componentDidMount() {
        this.setState(this.props.value);
        if (this.props.callback) {
            this.subscribe(this.props.callback);
        }
    }

    get() {
        return this.state;
    }

    update(newValue) {
        if (this.valueChangeCallbacks) {
            this.setState(newValue, this.valueChangeCallbacks.fire(true, this.state));
        }
    }

    error(errorValue) {
        if (this.valueChangeCallbacks) {
            this.setState(errorValue, this.valueChangeCallbacks.fire(false, errorValue));
        }
    }

    subscribe(cbk) {
        if (cbk)
            this.valueChangeCallbacks.add(cbk);
    }

    unsubscribe(cbk) {
        this.valueChangeCallbacks.remove(cbk);
    }

    createProvider() {
        let provider = {
            name: this.NAME,
            update: (newValue) => { this.update(newValue); },
            get: () => { return this.get },
            error: (errorValue) => { this.error(errorValue); }
        };
        return provider;
    }

    createConsumer() {
        return {
            name: this.NAME,
            get: () => { return this.get() },
            subscribe: (cbk) => { return this.subscribe(cbk); },
            unsubscribe: (cbk) => { return this.unsubscribe(cbk); }
        }
    }

    render() { return null; }

}

export class StorageApiPath extends StorageItem {
    static defaultProps = {
        value: {
            site: ""
        }
    }
    NAME = () => { return "StorageApiPath" };
}

export class StorageAuth extends StorageItem {
    static defaultProps = {
        value: {
            accessToken: "",
            refreshToken: ""
        }
    }
    NAME = () => { return "StorageAuth" };
}

export class StorageDevice extends StorageItem {

    static defaultProps = {
        value: {
            device: {
                id: { entityType: "DEVICE", id: "" },
                createdTime: 0,
                tenantId: null,
                customerId: null,
                name: "",
                type: "SensorAcuadori",
                additionalInfo: null,
            },
            devToken: "",
            telemetry: [] //array of telemetry items
        }
    }
    NAME = () => { return "StorageDevice" };
}

export class Storage {
    ApiPath = new StorageApiPath();
    Auth = new StorageAuth();
    Device = new StorageDevice();
}

export default DataStorage;
